import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Rates from "@/pages/Rates";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import UserDashboard from "@/pages/UserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

const Loading = () => (
  <div className="min-h-screen tb-glow flex items-center justify-center">
    <div className="text-fuchsia-300 font-head text-xl animate-pulse">TravisB…</div>
  </div>
);

function Protected({ children, role }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin")
    return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rates" element={<Rates />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <UserDashboard />
                </Protected>
              }
            />
            <Route path="/travisb-admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
